import { render, staticRenderFns } from "./ClassificationHelper.vue?vue&type=template&id=4b2b8e2c&scoped=true"
import script from "./ClassificationHelper.vue?vue&type=script&lang=js"
export * from "./ClassificationHelper.vue?vue&type=script&lang=js"
import style0 from "./ClassificationHelper.vue?vue&type=style&index=0&id=4b2b8e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b8e2c",
  null
  
)

export default component.exports